import { type BoardLayout } from '@inpart-io/padme-iap';

import { i18nService } from '@/services/i18n-service';

export const FILTERS: Record<string, string> = {
    TEXT_SEARCH: 'meetingSearchText',
    IMPORT_STATUS: 'importStatus',
    LEADS: i18nService.t('LEAD.LOW.PLUR'),
    COMPANY: i18nService.t('COMPANY.LOW.SING'),
    COMPANIES: i18nService.t('COMPANY.LOW.PLUR'),
    CONTACTS: i18nService.t('CONTACT.LOW.PLUR'),
    CONFERENCES: i18nService.t('CONFERENCE.LOW.PLUR'),
    MEETING_TYPE: 'meetingType',
    ATTENDEES: 'attendees',
    CONTACT_ATTENDEES: 'contactAttendees',
    USER_ATTENDEES: 'userAttendees',
    MEETING_DATE_BEGIN: 'dateBegin',
    MEETING_DATE_END: 'dateEnd'
};

export const MeetingListMode = {
    LEAD: 'meeting.lead',
    COMPANY: 'meeting.company',
    CONTACT: 'meeting.contact',
    CONFERENCE: 'meeting.conference',
    HUB: 'meeting.hub'
} as const;

export type IMeetingListMode = (typeof MeetingListMode)[keyof typeof MeetingListMode];

export interface ViewDefinition {
    type: BoardLayout;
    icon: string;
    tooltip: string;
}

export const MEETING_LIST_SETTINGS: Record<string, string> = {
    VIEW: 'meetingView'
};
